import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/ServicePage";
import { AUTOMACAO_PAGES } from "@/lib/automacao-pages";

const data = AUTOMACAO_PAGES["inteligencia-artificial-para-atendimento-empresarial"];

export const Route = createFileRoute("/inteligencia-artificial-para-atendimento-empresarial")({
  head: () => ({
    meta: [
      { title: data.seoTitle },
      { name: "description", content: data.seoDescription },
      { property: "og:title", content: data.seoTitle },
      { property: "og:description", content: data.seoDescription },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.svgmultimidia.com.br/inteligencia-artificial-para-atendimento-empresarial" },
    ],
    links: [{ rel: "canonical", href: "https://www.svgmultimidia.com.br/inteligencia-artificial-para-atendimento-empresarial" }],
  }),
  component: () => <ServicePage {...data.page} />,
});
